module.exports = __webpack_public_path__ + "img/10.fc3ba43d.png";